import type { ProgramsWithRelations } from "@ch/generated";
import ForwardArrowIcon from "@ch/assets/icons/pack/FowardArrowIcon.tsx";
import CheckMarkIcon3 from "@ch/assets/icons/pack/CheckmarkIcon3.tsx";
import WelcomeProjectModal from "@ch/pages/SubscriptionsPage/tabs/MyPlan/modals/WelcomeProjectModal.tsx";
import useDialogue from "@ch/helpers/hooks/useDialogue.ts";
import { useParams } from "react-router-dom";

interface IProps {
  program?: ProgramsWithRelations;
}
function ProjectDetails({ program }: IProps) {
  const { subscriptionId } = useParams();
  const { benefits, title, description } = program ?? {};

  const {
    dialogueId,
    handleOpenDialogue,
    handleCloseDialogue,
    isDialogueOpen,
  } = useDialogue();

  return (
    <div className="mx-auto flex max-w-[712px] flex-col gap-4 rounded-2xl border bg-white p-4 min-[640px]:flex-row min-[640px]:items-start min-[640px]:gap-5 lg:p-6">
      <div className="min-w-0 flex-1">
        <h2 className="text-2xl font-semibold text-black">{title}</h2>
        <p className="mt-4 text-sm">{description}</p>
        <div className="divider my-2" />
        <p className="mb-4 text-lg font-semibold">Benefits</p>
        <div className="grid grid-cols-2 gap-y-4">
          {benefits?.map((b, i) => {
            return (
              <div
                className="flex items-center gap-2 text-sm text-ink-700"
                key={i}
              >
                <CheckMarkIcon3 />
                {b.title}
              </div>
            );
          })}
        </div>
        <div className="divider" />
        {!subscriptionId && (
          <button
            className="btn-unstyled ml-auto mt-4 flex h-10 items-center justify-between gap-2 rounded-full bg-green px-4 text-sm text-white transition-colors"
            onClick={handleOpenDialogue}
            type="button"
          >
            <span>Continue</span>
            <span className="text-white">
              <ForwardArrowIcon height={24} width={24} />
            </span>
          </button>
        )}
      </div>
      <WelcomeProjectModal
        isDialogueOpen={isDialogueOpen}
        modalId={dialogueId}
        onClose={handleCloseDialogue}
        title={title}
      />
    </div>
  );
}

export default ProjectDetails;
